<script setup>
  import { onMounted, ref, watch } from "vue";
  import Multiselect from "vue-multiselect";

  const props = defineProps({
    sorts: {
      type: [],
      default: () => [],
      required: true,
    }
  });

  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  const emit = defineEmits(["update:sortOrder"]);

  const sortValue = ref(props.sorts.filter(sort => sort.selected )[0] || null);

  const sortOptions = ref(props.sorts);

  watch(sortValue, (newVal) => {
    if (newVal != null) {
      sortOptions.value.forEach(sort => {
        if (sort.value === newVal.value) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });
    }
    emit("update:sortOrder", newVal);
  });

  onMounted(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('order[series]')) {
      sortOptions.value.forEach(sort => {
        if (sort.value === url.searchParams.get('order[series]')) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });

      sortValue.value = sortOptions.value.filter(sort => sort.selected)[0];
    }

  });
</script>

<template>
  <div class="order-by-series-container">
    <multiselect
      v-model="sortValue"
      :options="sortOptions"
      :searchable="false"
      :allow-empty="true"
      label="name"
      track-by="value"
      placeholder="Order by Series..."
      class="meu-multiselect-customizado"
    >

      <template #singleLabel="{ option }">
        <span class="multiselect-label">{{ option.name }}</span>
      </template>
      <template #placeholder>
        <span class="multiselect-label">{{ trans('Order by Series...') }}</span>
      </template>
    </multiselect>
  </div>
</template>



<style scoped>
  .meu-multiselect-customizado {
    width: auto;
  }

  .meu-multiselect-customizado :deep(.multiselect__content-wrapper) {
    width: max-content;
    min-width: 100%;
    max-width: none;
  }

  .meu-multiselect-customizado :deep(.multiselect__content) {
    width: max-content;
  }

</style>
